import { useState } from "react";
import { ArrowLeft, Upload, Link2, RotateCcw } from "lucide-react";
import { validateWords } from "../game";

export default function Words({ words, custom, onImport, onRestore, onBack }) {
  const [url, setUrl] = useState("");
  const [msg, setMsg] = useState(null);

  const accept = (text) => {
    let data;
    try { data = JSON.parse(text); } catch { return setMsg({ ok: false, text: "El archivo no es JSON válido." }); }
    const err = validateWords(data);
    if (err) return setMsg({ ok: false, text: err });
    onImport(data);
    setMsg({ ok: true, text: `Importado: ${data.categorias.length} categorías.` });
  };

  const fromFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    f.text().then(accept);
    e.target.value = "";
  };

  const fromUrl = async () => {
    if (!url.trim()) return;
    try {
      const r = await fetch(url.trim());
      if (!r.ok) throw new Error();
      accept(await r.text());
    } catch {
      setMsg({ ok: false, text: "No se pudo descargar el JSON desde esa URL." });
    }
  };

  const total = words ? words.categorias.reduce((n, c) => n + c.pares.length, 0) : 0;

  return (
    <div className="screen">
      <div className="topbar">
        <button className="icon-btn" onClick={onBack} aria-label="Volver" data-testid="words-back-btn"><ArrowLeft size={22} /></button>
        <h1 className="screen-title">Palabras</h1>
      </div>

      <section className="glass section" data-testid="words-summary">
        <div className="section-head">
          <h2>Lista actual</h2>
          <span className="badge" data-testid="words-source">{custom ? "Importada" : "Original"}</span>
        </div>
        <p className="muted">{words ? `${words.categorias.length} categorías · ${total} pares` : "Cargando…"}</p>
        <ul className="cat-list">
          {words?.categorias.map((c) => <li key={c.nombre}><span>{c.nombre}</span><small>{c.pares.length}</small></li>)}
        </ul>
      </section>

      <section className="glass section">
        <h2>Importar JSON</h2>
        <label className="btn btn-ghost full" data-testid="import-file-label">
          <Upload size={18} /> Desde archivo
          <input type="file" accept=".json,application/json" hidden onChange={fromFile} data-testid="import-file-input" />
        </label>
        <div className="add-row mt">
          <input className="input" value={url} placeholder="https://…/palabras.json" onChange={(e) => setUrl(e.target.value)} data-testid="import-url-input" />
          <button className="btn btn-primary btn-square" onClick={fromUrl} aria-label="Importar desde URL" data-testid="import-url-btn"><Link2 size={20} /></button>
        </div>
        {msg && <p className={msg.ok ? "success" : "error"} data-testid="import-message">{msg.text}</p>}
        <p className="muted small">Formato: {'{ "version": 1, "categorias": [ { "nombre": "…", "pares": [ { "normal": "…", "impostor": "…" } ] } ] }'}</p>
      </section>

      <div className="actions">
        <button className="btn btn-ghost full" disabled={!custom} onClick={() => { onRestore(); setMsg({ ok: true, text: "Lista original restaurada." }); }} data-testid="restore-words-btn">
          <RotateCcw size={18} /> Restaurar JSON original
        </button>
      </div>
    </div>
  );
}
